import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from '@prosolve/common-components-ui'
import { FaLink } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { copySvgToClipboardAsImage } from '../../../utils'

export default ({
  url = '',
  displayUrl = url,
  text = '',
  onClose,
}) => {

  const qrCodeRef = useRef()

  const [isLinkCopied, setIsLinkCopied] = useState(false)
  const [isQRCopied, setIsQRCopied] = useState(false)

  const onCopyLink = () => {
    if (!isLinkCopied) {
      navigator.clipboard.writeText(url)
      setIsLinkCopied(true)
    }
  }

  const onCopyQRCode = async () => {
    if (!isQRCopied) {
      await copySvgToClipboardAsImage(qrCodeRef.current)
      setIsQRCopied(true)
    }
  }

  useEffect(() => {
    if (isLinkCopied || isQRCopied) {
      setTimeout(() => {
        onClose()
      }, 1000)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLinkCopied, isQRCopied])

  return (
    <Modal title='' isFullScreen={true} onClose={onClose}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#565656'
      }}>
        <div style={{ 
          fontSize: '36px',
          textAlign: 'center'
        }}>
          {text}
        </div>
        <div style={{
          fontSize: '36px',
          color: '#33AFE7',
          textAlign: 'center',
          wordBreak: 'break-word'
        }}>
          {displayUrl}
        </div>
        <div>
          <QRCode ref={qrCodeRef} value={url} />
        </div>
        <div>
          <Button
            $colored={true}
            $disabled={isLinkCopied}
            style={{
              marginTop: '20px',
              display: 'inline-flex',
              // height: '120px',
              padding: '12px 30px',
              border: 'none',
            }}
            onClick={onCopyLink}
          >
            <FaLink style={{ marginRight: '15px', color: '#ffffff', fontSize: '28px' }} />
            <span style={{ fontSize: '28px', fontWeight: 'bold' }}>{isLinkCopied ? 'Link copied to clipboard' : 'Copy Link'}</span>
          </Button>
          <Button
            $colored={true}
            $disabled={isQRCopied}
            style={{
              marginTop: '20px',
              display: 'inline-flex',
              // height: '120px',
              padding: '12px 30px',
              border: 'none',
              marginLeft: '20px'
            }}
            onClick={onCopyQRCode}
          >
            <FaLink style={{ marginRight: '15px', color: '#ffffff', fontSize: '28px' }} />
            <span style={{ fontSize: '28px', fontWeight: 'bold' }}>{isQRCopied ? 'QR Code copied to clipboard' : 'Copy QR Code'}</span>
          </Button>
        </div>
      </div>
    </Modal>
  )
}